export default __webpack_public_path__ + "static/Grey-Checkout-6e02b88125131447efa38bf28974a66a.png";